function extractQuickViewContent(htmlString) {
  if (!htmlString || typeof htmlString !== 'string') {
    return '';
  }
  try {
    const parsed = new DOMParser().parseFromString(htmlString, 'text/html');
    if (parsed.querySelector('parsererror')) {
      return '';
    }
    const node =
      parsed.getElementById('quickview-product-content') ||
      parsed.querySelector('[id="quickview-product-content"]');
    return node ? node.innerHTML : '';
  } catch (e) {
    return '';
  }
}

function applyProfessionalCollectionLabel(qvRoot, triggerEl) {
  if (!qvRoot) return;

  const card = triggerEl?.closest?.('[data-tw-professional="true"], .tw-card-professional');
  const fromCard = Boolean(card);
  let professionalRoot = qvRoot.querySelector('.tw-qv-professional');

  // Card says professional but Liquid QV didn't — transform commerce chrome client-side.
  if (fromCard && !professionalRoot) {
    const content =
      qvRoot.querySelector('.product-content-container') ||
      qvRoot.querySelector('.product-info')?.closest('.product-content-container') ||
      qvRoot.querySelector('.product-info');
    if (content) {
      content.classList.add('tw-qv-professional', 'flex', 'flex-col', 'self-stretch');
      professionalRoot = content;
    }
    const info = qvRoot.querySelector('.product-info');
    if (info) {
      info.classList.add('h-full', 'flex', 'flex-col');
      const flex = info.querySelector(':scope > .flex');
      if (flex) {
        flex.classList.add('flex-col', 'flex-1', 'h-full', 'w-full', 'min-h-0');
        flex.classList.remove('flex-wrap');
      }
    }

    const hideSelectors = [
      '.x-block-price',
      '.pricearea',
      '.x-block-badges',
      '.x-badges-container',
      '.x-labels-container',
      '.x-quantity-selector',
      '.product-form__quantity',
      '.x-variant-picker',
      '.x-block-view-detail',
      '.payment-button',
      '.shopify-payment-button',
    ];
    hideSelectors.forEach((sel) => {
      qvRoot.querySelectorAll(sel).forEach((node) => {
        node.style.display = 'none';
        node.setAttribute('hidden', '');
      });
    });
    // Rating stars (review-product snippet has no stable block wrapper class)
    qvRoot.querySelectorAll('.spr-header, .spr-starrating, .jdgm-preview-badge, .rating, [class*="review"]').forEach((node) => {
      const wrap = node.closest('.mb-4, .mb-5, .md\\:mb-6, div') || node;
      if (wrap.closest('.x-block-buy-buttons') || wrap.closest('.tw-qv-professional-collection')) return;
      wrap.style.display = 'none';
      wrap.setAttribute('hidden', '');
    });
    // Bare "(0)" rating rows under the title
    qvRoot.querySelectorAll('.product-info .flex > div').forEach((node) => {
      const t = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^\(?\d+\)?$/.test(t) || /^\(\d+\)$/.test(t)) {
        node.style.display = 'none';
        node.setAttribute('hidden', '');
      }
      if (node.querySelector('svg') && t.match(/^\(?\d+\)?$/)) {
        node.style.display = 'none';
        node.setAttribute('hidden', '');
      }
    });

    // Hide vendor lines (keep/replace with collection label below).
    qvRoot.querySelectorAll('.x-block-vendor').forEach((node) => {
      if (!node.classList.contains('tw-qv-professional-collection-wrap')) {
        node.remove();
      }
    });
    qvRoot.querySelectorAll('.product-info > .flex > p.italic').forEach((node) => {
      if (!node.classList.contains('tw-qv-professional-collection')) {
        node.remove();
      }
    });

    // Replace buy / sold-out / Shop Pay with find-a-salon CTA.
    const buyBlock =
      qvRoot.querySelector('.x-block-buy-buttons') ||
      qvRoot.querySelector('.button-product');
    if (buyBlock && !buyBlock.querySelector('[data-tw-salon-cta]')) {
      const salonUrl = '/pages/find-a-salon';
      const label = 'Scopri il trattamento in salone';
      buyBlock.innerHTML = '';
      buyBlock.classList.add('mt-auto');
      const a = document.createElement('a');
      a.href = salonUrl;
      a.setAttribute('data-tw-salon-cta', 'true');
      a.className =
        'relative add_to_cart_button button button-solid leading-none w-full mb-3 pt-3 pb-3 md:pt-3.5 md:pb-3.5 inline-flex items-center justify-center text-center';
      a.setAttribute('aria-label', label);
      a.textContent = label;
      buyBlock.appendChild(a);
    }
  }

  if (!professionalRoot && !fromCard) return;
  if (!professionalRoot) return;

  // Remove leftover vendor lines so only the collection remains.
  qvRoot.querySelectorAll('.x-block-vendor').forEach((node) => {
    if (!node.classList.contains('tw-qv-professional-collection-wrap')) {
      node.remove();
    }
  });
  qvRoot.querySelectorAll('.product-info > .flex > p.italic').forEach((node) => {
    if (!node.classList.contains('tw-qv-professional-collection')) {
      node.remove();
    }
  });

  const collectionTitle = card
    ?.getAttribute?.('data-tw-qv-collection')
    ?.trim();
  if (!collectionTitle) return;

  let label = qvRoot.querySelector('.tw-qv-professional-collection');
  if (!label) {
    const infoFlex = qvRoot.querySelector('.product-info > .flex');
    if (!infoFlex) return;
    label = document.createElement('p');
    label.className =
      'tw-qv-professional-collection w-full mb-1 italic p-break-words text-[rgba(var(--colors-text))]';
    const variantTitle = infoFlex.querySelector('[id^="product-variant-title-"]');
    if (variantTitle) {
      variantTitle.after(label);
    } else {
      infoFlex.insertBefore(label, infoFlex.firstChild);
    }
  }
  label.textContent = collectionTitle;
}

document.addEventListener('alpine:init', () => {
    const qvCfg = Object.assign(
      {
        sectionId: '',
        enabled: true,
        buttonLabel: '',
        show_atc_button: true,
        atc_btn_bottom: false,
        atc_btn_image_desktop: true,
      },
      typeof window.xQuickView === 'object' && window.xQuickView !== null ? window.xQuickView : {}
    );
    qvCfg.enabled = true;
    const syncQuickViewFromWindow = () => {
      const w = typeof window !== 'undefined' ? window.xQuickView : null;
      const s = Alpine.store('xQuickView');
      if (!w || !s) return;
      if (w.sectionId) s.sectionId = w.sectionId;
      s.enabled = true;
      if (typeof w.show_atc_button === 'boolean') s.show_atc_button = w.show_atc_button;
      if (typeof w.atc_btn_bottom === 'boolean') s.btn_atc_bottom = w.atc_btn_bottom;
      if (typeof w.atc_btn_image_desktop === 'boolean') {
        s.atc_btn_image_desktop = w.atc_btn_image_desktop;
      }
      if (w.buttonLabel !== undefined && w.buttonLabel !== '') {
        s.buttonLabel = w.buttonLabel;
      }
    };

    Alpine.store('xQuickView', {
      sectionId: qvCfg.sectionId,
      enabled: qvCfg.enabled,
      buttonLabel: qvCfg.buttonLabel,
      show_atc_button: qvCfg.show_atc_button,
      btn_atc_bottom: qvCfg.atc_btn_bottom,
      atc_btn_image_desktop: qvCfg.atc_btn_image_desktop,
      show: false,
      loading: false,
      currentVariant: '',
      cachedResults: [],
      cachedfetch: [],
      loadingUrls: [],
      loadedChooseOptions: [],
      loadedChooseOptionsID: [],
      selected: false,
      loadingChooseOption: false,
      isMiniCart: false,
      buttonQuickView: "",
      addListener() {
        document.addEventListener('eurus:cart:items-changed', () => {
          this.cachedResults = [];
        });
      },
      showBtn(_enable, showATCButton, textBtn) {
        this.enabled = true;
        this.buttonLabel = textBtn;
        this.show_atc_button = showATCButton;
      },
      load(url, el, optionId) {
        const qvRoot = document.getElementById('quickview-product-content');
        // #region agent log
        fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:load:entry',message:'load called',data:{hasQvRoot:!!qvRoot,hasQuickView:!!document.getElementById('QuickView'),url:String(url||'').slice(0,120),optionId:String(optionId||'')},timestamp:Date.now(),hypothesisId:'H-A'})}).catch(()=>{});
        // #endregion
        if (!qvRoot) {
          return;
        }
        this.loading = true;

        requestAnimationFrame(() => {
          setTimeout(() => {
            if (this.buttonQuickView == '') {
              this.buttonQuickView = el;
            }
            let sectionId =
              (typeof window !== 'undefined' &&
                window.xQuickView &&
                window.xQuickView.sectionId) ||
              this.sectionId ||
              '';
            if (!sectionId && typeof window !== 'undefined' && window.xQuickView) {
              sectionId = window.xQuickView.sectionId || '';
            }
            if (!sectionId) {
              // #region agent log
              fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:load:noSectionId',message:'sectionId empty abort',data:{storeSectionId:String(this.sectionId||'')},timestamp:Date.now(),hypothesisId:'H-B'})}).catch(()=>{});
              // #endregion
              this.loading = false;
              return true;
            }

            let productUrl;
            try {
              const href =
                url.indexOf('http') === 0
                  ? url
                  : new URL(url, window.location.origin).href;
              const u = new URL(href);
              u.searchParams.delete('section_id');
              u.searchParams.delete('sections');
              u.searchParams.delete('variant');
              const variantText = document.getElementById(
                'current-variant-' + optionId
              )?.innerText?.trim();
              if (variantText) {
                u.searchParams.set('variant', variantText);
              }
              // Shopify Section Rendering API uses ?sections= (JSON); legacy themes used section_id=
              u.searchParams.set('sections', sectionId);
              productUrl = u.pathname + u.search + (u.hash || '');
            } catch (e) {
              const variantText = document.getElementById(
                'current-variant-' + optionId
              )?.innerText?.trim();
              productUrl = variantText
                ? `${url}?variant=${variantText}&sections=${encodeURIComponent(sectionId)}`
                : `${url}?sections=${encodeURIComponent(sectionId)}`;
            }
            productUrl = productUrl.replace(/\s+/g, '');

            if (this.cachedResults[productUrl]) {
              qvRoot.innerHTML = this.cachedResults[productUrl];
              applyProfessionalCollectionLabel(qvRoot, el || this.buttonQuickView);
              this.loading = false;
              return true;
            }

            if (this.cachedfetch[productUrl]) {
              return true;
            }

            this.cachedfetch[productUrl] = true;

            const finish = () => {
              this.loading = false;
              this.cachedfetch[productUrl] = false;
            };

            // #region agent log
            fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:load:fetchStart',message:'fetch quick view',data:{productUrl:String(productUrl||'').slice(0,200),sectionId:String(sectionId||'').slice(0,80)},timestamp:Date.now(),hypothesisId:'H-B'})}).catch(()=>{});
            // #endregion

            fetch(productUrl)
              .then((r) => r.text())
              .then(async (responseText) => {
                let content = '';
                let usedJsonFallback = false;
                let usedLegacySectionId = false;
                const trimmed = (responseText || '').trim();
                if (trimmed.startsWith('{')) {
                  try {
                    const j = JSON.parse(trimmed);
                    const fragment =
                      j[sectionId] ||
                      j['quick-view'] ||
                      (typeof j === 'object' &&
                      j !== null &&
                      Object.keys(j).length
                        ? j[Object.keys(j)[0]]
                        : null);
                    if (fragment && typeof fragment === 'string') {
                      content = extractQuickViewContent(fragment);
                      if (!content) {
                        content =
                          extractQuickViewContent(
                            `<div class="qv-root">${fragment}</div>`
                          ) || fragment;
                      }
                      usedJsonFallback = true;
                    }
                  } catch (e) {}
                }
                if (!content) {
                  content = extractQuickViewContent(responseText);
                }
                if (
                  !content &&
                  sectionId &&
                  responseText
                ) {
                  try {
                    const href =
                      url.indexOf('http') === 0
                        ? url
                        : new URL(url, window.location.origin).href;
                    const uLegacy = new URL(href);
                    uLegacy.searchParams.delete('sections');
                    uLegacy.searchParams.set('section_id', sectionId);
                    const variantText = document.getElementById(
                      'current-variant-' + optionId
                    )?.innerText?.trim();
                    if (variantText) {
                      uLegacy.searchParams.set('variant', variantText);
                    }
                    const legacyUrl =
                      uLegacy.pathname + uLegacy.search + (uLegacy.hash || '');
                    const rLegacy = await fetch(legacyUrl);
                    const textLegacy = await rLegacy.text();
                    content = extractQuickViewContent(textLegacy);
                    usedLegacySectionId = !!content;
                  } catch (e) {}
                }
                // #region agent log
                fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:load:parsed',message:'fetch response parsed',data:{responseLen:(responseText&&responseText.length)||0,contentLen:(content&&content.length)||0,usedJsonFallback:!!usedJsonFallback,usedLegacySectionId:!!usedLegacySectionId},timestamp:Date.now(),hypothesisId:'H-C'})}).catch(()=>{});
                // #endregion
                if (content && qvRoot) {
                  qvRoot.innerHTML = content;
                  applyProfessionalCollectionLabel(qvRoot, el || this.buttonQuickView);
                  this.cachedResults[productUrl] = content;
                }
              })
              .catch((err) => {
                // #region agent log
                fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:load:fetchErr',message:'fetch failed',data:{err:String(err&&err.message?err.message:err)},timestamp:Date.now(),hypothesisId:'H-E'})}).catch(()=>{});
                // #endregion
              })
              .finally(finish);

            return true;
          }, 0);
        });
      },
      async loadChooseOptions(url, el, optionId, index) {
        setTimeout(async () => { 
          let getVariant = document.getElementById('current-variant-' + optionId)?.innerText;
          let urlProduct = `${url}?section_id=choose-option&page=${index}`;
          
          let destinationElm = document.getElementById('choose-options-' + optionId)?.querySelector('.choose-options');
          let destinationElmMobile = document.getElementById('choose-options-mobile');
          let loadingEl = document.getElementById('choose-options-' + optionId)?.querySelector('.icon-loading');
          
          if (this.loadedChooseOptions[urlProduct]) {
            if (window.innerWidth > 767) {
              if (!el.closest('.card-product').querySelector('#choose-options-' + optionId)?.querySelector('.choose-options-content')) {
                destinationElm && (destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElmMobile && (destinationElmMobile.innerHTML = '');  
              }
              if (destinationElm) {
                if (destinationElm.querySelector(".add_to_cart_button")) {
                  destinationElm.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElm.querySelector(".label-btn-quickview")) {
                  destinationElm.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            } else {
              if (!el.closest('.card-product').querySelector('#choose-options-mobile')) {
                destinationElmMobile && (destinationElmMobile.innerHTML = this.loadedChooseOptions[urlProduct]);
                destinationElm && (destinationElm.innerHTML = '');
              }
              if (destinationElmMobile) {
                if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                  destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                }
                if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                  destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                }
              }
            }
            return true;
          }
          
          try {
            if (loadingEl) {
              loadingEl.classList.remove('hidden');
            }
            this.loadingChooseOption = true;
            if (!this.loadingUrls.includes(urlProduct)) {
              this.loadingUrls.push(urlProduct);
              await fetch(urlProduct).then((response) => response.text()).then((content) => {
                const parser = new DOMParser();
                const parsedContent = parser.parseFromString(content, 'text/html').getElementById("choose-options-content").innerHTML;
                
                if (parsedContent) {
                  if (window.innerWidth > 767) {
                    destinationElmMobile && (destinationElmMobile.innerHTML = '');
                    destinationElm && (destinationElm.innerHTML = parsedContent);
                  } else {
                    destinationElmMobile && (destinationElmMobile.innerHTML = parsedContent);
                    destinationElm && (destinationElm.innerHTML = '');
                  }
                  this.loadedChooseOptions[urlProduct] = parsedContent;
                }
                if (loadingEl) {
                  loadingEl.classList.add('hidden');
                }  
              }).finally(() => {
                const index = this.loadingUrls.indexOf(urlProduct);
                if (index !== -1) this.loadingUrls.splice(index, 1);  
                if (window.innerWidth > 767) {
                  if (destinationElm) {
                    if (destinationElm.querySelector(".add_to_cart_button")) {
                      destinationElm.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElm.querySelector(".label-btn-quickview")) {
                      destinationElm.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                } else {
                  if (destinationElmMobile) {
                    if (destinationElmMobile.querySelector(".add_to_cart_button")) {
                      destinationElmMobile.querySelector(".add_to_cart_button").style.display="block";
                    }
                    if (destinationElmMobile.querySelector(".label-btn-quickview")) {
                      destinationElmMobile.querySelector(".label-btn-quickview").style.display="none";
                    }
                  }
                }      
              });
            }
            this.loadingChooseOption = false;
          } catch (error) {
            console.log(error);
          }
        }, 0)
      },
      open(isMiniCart = false) {
        const hasShell =
          typeof document !== 'undefined' &&
          document.getElementById('QuickView') &&
          document.getElementById('quickview-product-content');
        if (!hasShell) {
          // #region agent log
          fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:open:abort',message:'open aborted — Quick View section not in DOM',data:{hasQuickView:!!(typeof document!=='undefined'&&document.getElementById('QuickView')),hasQvRoot:!!(typeof document!=='undefined'&&document.getElementById('quickview-product-content'))},timestamp:Date.now(),hypothesisId:'H-dom'})}).catch(()=>{});
          // #endregion
          return;
        }
        let showBefore = this.show;
        this.isMiniCart = isMiniCart;
        this.show = true;
        let popupOk = false;
        try {
          Alpine.store('xPopup').open = true;
          popupOk = true;
        } catch (e) {}
        // #region agent log
        fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:open',message:'open()',data:{showBefore:!!showBefore,showAfter:!!this.show,isMiniCart:!!isMiniCart,popupOk},timestamp:Date.now(),hypothesisId:'H-D'})}).catch(()=>{});
        // #endregion
      },
      close() {
        // #region agent log
        fetch('http://127.0.0.1:7931/ingest/8fa91d0d-6678-4a06-a63b-f87d60e6d1c0',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'038482'},body:JSON.stringify({sessionId:'038482',location:'quick-view.js:close',message:'close()',data:{showBefore:!!this.show,miniCartOpen:!!(Alpine.store('xMiniCart')&&Alpine.store('xMiniCart').open)},timestamp:Date.now(),hypothesisId:'H-away'})}).catch(()=>{});
        // #endregion
        this.show = false;
        this.buttonQuickView = '';
        if(!Alpine.store('xMiniCart').open) {
          Alpine.store('xPopup').close();
        }
      },
      focusQuickView(quickView, btnClose) {
        if ( !this.selected ) { 
          Alpine.store('xFocusElement').trapFocus(quickView, btnClose);
        }
      },
      removeFocusQuickView() {
        if ( !this.selected ) { 
          const elementActive = document.getElementById("button_quickview");
          Alpine.store('xFocusElement').removeTrapFocus(elementActive);
        }
      },
      closePopupMobile() {
        this.openPopupMobile = false;
      },
      showChooseOption(id, el) {
        this.openPopupMobile = true;
        const product = el.closest(".card-product");
        const addToCartBtn = product.querySelector('.choose-options')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtn = product.querySelector('.choose-options')?.querySelector('.label-btn-quickview')
        const addToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.add_to_cart_button');
        const iconAddToCartBtnMobile = document.querySelector('.choose-options-mobile')?.querySelector('.label-btn-quickview')

        if(addToCartBtn && iconAddToCartBtn && window.innerWidth > 767){
          addToCartBtn.style.display="block"
          iconAddToCartBtn.style.display="none"
        }else if(addToCartBtnMobile && iconAddToCartBtnMobile){
          addToCartBtnMobile.style.display="block"     
          iconAddToCartBtnMobile.style.display="none"
        }       
      },
      clickInsideQuickView(evt, $el) {
        if(this.isMiniCart) {
          evt.stopPropagation();
          this.show = false;
          Alpine.store('xPopup').close();
        }
      },
      clickInsideContentQuickView(evt) {
        evt.stopPropagation();
      }
    });

    syncQuickViewFromWindow();
    queueMicrotask(syncQuickViewFromWindow);
    window.addEventListener('load', syncQuickViewFromWindow);
});